import api from "@/lib/api";

export async function fetchEpisodes(params = {}) {
  const { data } = await api.get("/episodes", { params });
  return data;
}
export async function fetchEpisode(slug) {
  const { data } = await api.get(`/episodes/${slug}`);
  return data;
}
export async function adminListEpisodes(params = {}) {
  const { data } = await api.get("/admin/episodes", { params });
  return data;
}
export async function adminCreateEpisode(payload) {
  const { data } = await api.post("/admin/episodes", payload);
  return data;
}
export async function adminUpdateEpisode(id, payload) {
  const { data } = await api.put(`/admin/episodes/${id}`, payload);
  return data;
}
export async function adminDeleteEpisode(id) {
  await api.delete(`/admin/episodes/${id}`);
}
